export const SearchReferrer = {
	PRE_QUERY_QF_SUGGESTION: 'pre-query-qf-suggestion',
} as const;
